import { create } from 'zustand'
import type { Snapshot } from '@/api/types/readiness'

// ── Compared pair (Iteration 6 §2.2, Note 1) ────────────────────────────────
// One store holds `{ fromId, toId }` per org × index. The pickers, the matrix,
// the rail, the chart rings and the Progress Report all read it, so the four
// surfaces cannot disagree. `live` is the Live column. The Progress page also
// mirrors it into `returnTo.viewState` so back navigation restores it.

export const LIVE = 'live'

export interface ComparePair {
  fromId: string | null
  toId: string | null
}

interface ComparePairState {
  pairs: Record<string, ComparePair>
  setPair: (key: string, pair: ComparePair) => void
}

export const pairKey = (orgId: string, indexId: string) => `${orgId || 'anon'}::${indexId}`

export const useComparePairStore = create<ComparePairState>((set) => ({
  pairs: {},
  setPair: (key, pair) => set((s) => ({ pairs: { ...s.pairs, [key]: pair } })),
}))

// The default pair is the last saved assessment → Live (§4.1). A stored id
// that no longer resolves (assessment deleted, other tenant) falls back.
export function resolvePair(pair: ComparePair | undefined | null, snapshots: Snapshot[]): { fromId: string; toId: string } {
  const ids = new Set<string>([LIVE, ...snapshots.map((s) => s.id)])
  const last = snapshots[snapshots.length - 1]?.id ?? LIVE
  const fromId = pair?.fromId && ids.has(pair.fromId) ? pair.fromId : last
  const toId = pair?.toId && ids.has(pair.toId) ? pair.toId : LIVE
  return { fromId, toId }
}
